import { Image } from '../Image/Image';
import { Title } from '../Title/Title';
import styles from './UpsaleProgressChart.module.scss';
export const UpsaleProgressChart = ({content})=>{
  if(!content){
    return;
  }
  const {title,chart,promise,days} = content;
return (
  <>
    {title && <Title dangerouslySetInnerHTML={{ __html:title }} tag="h2" className={styles.title}/>}
    <div className={styles.wrapper}>
      {chart && <Image className={styles.chart} src={chart}/>}
      {promise && <div className={styles.promise} dangerouslySetInnerHTML={{ __html:promise }} />}
      {days && <div className={styles.days} dangerouslySetInnerHTML={{ __html:days }} />}
    </div>
  </>
)
}